import moment from 'moment'

// import {getToday} from "@/util/date.js";

export const calcDate = (date1, date2) => {
    let date3 = date2 - date1;

    let days = Math.floor(date3 / (24 * 3600 * 1000))

    let leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
    let hours = Math.floor(leave1 / (3600 * 1000))

    let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
    let minutes = Math.floor(leave2 / (60 * 1000))

    let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
    let seconds = Math.round(date3 / 1000)
    return {
        leave1,
        leave2,
        leave3,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
    }
}

/**
 * 日期格式化
 */
export function dateFormat(date, format) {
    format = format || 'yyyy-MM-dd hh:mm:ss';
    if (date !== 'Invalid Date') {
        let o = {
            "M+": date.getMonth() + 1, //month
            "d+": date.getDate(), //day
            "h+": date.getHours(), //hour
            "m+": date.getMinutes(), //minute
            "s+": date.getSeconds(), //second
            "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
            "S": date.getMilliseconds() //millisecond
        }
        if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (let k in o)
            if (new RegExp("(" + k + ")").test(format))
                format = format.replace(RegExp.$1,
                    RegExp.$1.length === 1 ? o[k] :
                        ("00" + o[k]).substr(("" + o[k]).length));
        return format;
    }
    return '';

}

export function testisoverlap(arr) {
    //判断时间是否重叠
    //   let dateAr = [
    //     { s: '01:00', e: '14:08' },
    //     { s: '01:04', e: '02:05' },
    //     { s: '05:21', e: '08:00' },
    //     { s: '10:20', e: '12:08' },
    //  ]
    let dateAr = arr;

    function Fn() {
        for (let k in dateAr) {
            if (!judege(k)) {
                return false
            }
        }
        return true
    }

    function judege(idx) {
        for (let k in dateAr) {
            if (idx !== k) {
                if (dateAr[k].s <= dateAr[idx].s && dateAr[k].e >= dateAr[idx].s) {
                    return false
                }
                if (dateAr[k].s <= dateAr[idx].e && dateAr[k].e >= dateAr[idx].e) {
                    return false
                }
            }
        }
        return true
    }
    return Fn()
}

/***获取当前日期 返回数组[a,b] */
export function getToday() {
    let nowDate = new Date().getTime();
    return [moment(nowDate).format('YYYY-MM-DD'), moment(nowDate).format('YYYY-MM-DD')]
}

export function  getTodayTime(){
    let nowDate = new Date().getTime();
    return [moment(nowDate).format('YYYY-MM-DD HH:mm:ss'), moment(nowDate).format('YYYY-MM-DD HH:mm:ss')]

}

export function getyestoday() {
    let nowDate = new Date().getTime();
    nowDate = nowDate - 24 * 60 * 60 * 1000;
    return [moment(nowDate).format('YYYY-MM-DD'), moment(nowDate).format('YYYY-MM-DD')]
}

export function getnextday() {
    let nowDate = new Date().getTime();
    nowDate = nowDate + 24 * 60 * 60 * 1000;
    return [moment(nowDate).format('YYYY-MM-DD'), moment(nowDate).format('YYYY-MM-DD')]
}

export function weekfirstlastday() {
    let startDate = moment().isoWeekday(1).format('YYYY-MM-DD');
    let endDate = moment().isoWeekday(7).format('YYYY-MM-DD');
    return [startDate, endDate]
}

export function prewweek() {
    let startDate = moment().subtract(1,'weeks').isoWeekday(1).format('YYYY-MM-DD');
    let endDate = moment().subtract(1,'weeks').isoWeekday(7).format('YYYY-MM-DD');
    return [startDate, endDate]
}

export function monthfirstlastday() {
    let startDate = moment().startOf('month').format('YYYY-MM-DD');
    let endDate = moment().endOf('month').format('YYYY-MM-DD');
    return [startDate, endDate]
}

export function lastMonthFirstEndDay() {
    let startDate = moment().add(-1, 'months').startOf('month').format('YYYY-MM-DD');
    let endDate = moment().add(-1, 'months').endOf('month').format('YYYY-MM-DD');
    return [startDate, endDate]
}

export function yearFirstEndDay() {
    let startDate = moment().startOf('years').format('YYYY-MM-DD');
    let endDate = moment().endOf('years').format('YYYY-MM-DD');
    return [startDate, endDate]
}

export function monthfirstdayandtoday() {
    let startDate = moment().startOf('month').format('YYYY-MM-DD');
    let endDate = moment().format('YYYY-MM-DD');
    return [startDate, endDate]
}

export function prevmonthfirstlastday() {
    let startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    let endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    return [startDate, endDate]
}

export function getprewdays(days){
    let startDate = moment().subtract(days,'days').format('YYYY-MM-DD');
    let endDate = moment().format('YYYY-MM-DD');
    return [startDate, endDate]
}

export function getprewmonth(month){
    let startDate = moment().subtract(month,'months').format('YYYY-MM-DD');
    let endDate = moment().format('YYYY-MM-DD');
    return [startDate, endDate]
}

export function getprewyear(year){
    let startDate = moment().subtract(year,'years').format('YYYY-MM-DD');
    let endDate = moment().format('YYYY-MM-DD');
    return [startDate, endDate]
}



/**
 * 获取当前月期号
 * 返回格式: YYYY-mm
 * */
export function getCurrentMonthIssue(date) {
    let month = parseInt(date.getMonth() + 1);
    if (month < 10) {
        month = '0' + month
    }
    return date.getFullYear() + "-" + month;
}


/***
 * 将时间转为苹果支持的格式
 * 
 */

export function replaceTimeSeparator(time) {
    
    //验证是否是时间格式
    let  isDate = function (value) {
        return Object.prototype.toString.call(value) === '[object Date]' && !isNaN(value.getTime());
    }

    if (typeof time === 'undefined' || time === null || time === '') {
        return '';
    }
    if(isDate(time)){
        time = moment(time).format('YYYY-MM-DD hh:mm:ss');
    }
    return time.replace(/-/g, '/');
}